const apps = []
if (process.env.VUE_APP_MODE === 'production') {
  apps.push({
    name: 'dps',
    entry: 'https://h5.retdata.com/dps/index.html',
    activeRule: '/dps'
  })
} else if (process.env.VUE_APP_MODE === 'staging') {
  apps.push({
    name: 'dps',
    entry: 'https://h5-dev.retdata.com/dps/index.html',
    activeRule: '/dps'
  })
} else {
  apps.push({
    name: 'dps',
    entry: 'http://localhost:8082/dps/index.html',
    activeRule: '/dps'
  })
}
export default {
  dpsUri: process.env.VUE_APP_DPS_URI,
  clientId: process.env.VUE_APP_CLIENT_ID,
  baseUrl: document.location.origin + '/',
  apps
}
